import { Modal } from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';

const GenericModal = ({ children, isOpen = false, id, onCloseModal }) => {
  return (
    <>
      <style>
        {`
    
        .generic-modal {
            background:#1f2937 !important;
            color:white;
        }

          @media screen and (min-width:750px) {
            .generic-modal {
              width: 650px;
              height:500px
            }
          }
          @media screen and (max-width:750px) {
            .generic-modal {
              min-width: 91vw;
              height:80vh;
            }
          }
        `}
      </style>
      <Modal
        classNames={{
          modalContainer: 'md:mt-32 generic-modal-container',
          modal: 'generic-modal rounded',
        }}
        modalId={id}
        open={isOpen}
        onClose={onCloseModal}
      >
        {children}
      </Modal>
    </>
  );
};

export default GenericModal;
